export var IdTournamentPersistence;
(function (IdTournamentPersistence) {
    IdTournamentPersistence["LastTournament"] = "LastTournament";
    IdTournamentPersistence["Confirmed"] = "Confirmed";
})(IdTournamentPersistence || (IdTournamentPersistence = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/IdTournamentPersistence.ts
// module id = 476
// module chunks = 3